import './oProgressBar.scss';

interface IProps {
  isDisabled?: boolean;
  percentage: number;
}

const OProgressBar: React.FC<IProps> = ({ percentage = 0, isDisabled }) => {
  return (
    <div className="o-progressbar-container">
      <div
        className={`inner-bar ${isDisabled ? 'disabled-bar' : ''}`}
        style={{
          width: `${percentage}%`,
        }}
      ></div>
    </div>
  );
};

export default OProgressBar;
